<template>
  <section class="section2">
    <div class="bg"></div>
    <div class="container">
      <div class="section2-step-title">
        <!-- <div class="step-title-bg">
          <h4>HOW TO PAPER TRADE</h4>
        </div> -->

        <div class="section2-step flex-center">
          <CommonCard v-for="(l, index) in cardList" :key="index" :data="l" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import CommonCard from "./Card.vue";

export default {
  name: "Section2",
  data() {
    return {
      cardList: [
        {
          index: "1",
          title: "STEP 01",
          text: "Download and set up f(x)Wallet (IOS/Android)",
          theme: "steps",
        },
        {
          index: "2",
          title: "STEP 02",
          text: "Use f(x)Wallet to scan QRCode on desktop browser",
          theme: "step1",
        },
        {
          index: "3",
          title: "STEP 03",
          text: "Authorize and confirm the connection",
          theme: "step2",
        },
        {
          index: "4",
          title: "STEP 04",
          text: "Receive a Starter NFT in your f(x)Wallet and start trading!",
          theme: "step3",
          but: {
            url: process.env.VUE_APP_DOWNLOAD,
            text: "Get f(x)Wallet",
            blank: true,
          },
        },
      ],
    };
  },
  components: {
    CommonCard,
  },
};
</script>
<style lang="scss" scoped>
.section2 {
  position: relative;
  z-index: 2;
  .bg {
    overflow: hidden;
    position: absolute;
    pointer-events: none;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    .section2-bg1 {
      position: absolute;
      top: 0%;
      right: 0%;
      filter: blur(1148px);
      transform: translate(0%, -80%);
      width: 1148.35px;
      height: 1148.4px;
      background-image: radial-gradient(
        ellipse 45.7% 45.7% at 50% 50%,
        #a6f616 0%,
        rgba(43, 147, 163, 0.01) 99.39%,
        rgba(166, 246, 22, 0) 100%
      );
    }

    .section2-bg2 {
      position: absolute;
      filter: blur(1148px);
      z-index: 0;
      width: 1148.1px;
      height: 1143.22px;
      top: -50%;
      left: 50%;
      transform: translate(-50%, 0);
      background-image: radial-gradient(
        ellipse 45.7% 45.7% at 50% 50%,
        #18eed8 0%,
        rgba(43, 147, 163, 0.01) 99.39%,
        rgba(43, 147, 163, 0) 100%
      );
    }
  }

  .container {
    background-color: #ffffff;
    position: relative;
    padding-top: 237px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 285px;
  }

  .step-title-bg {
    text-align: center;
    position: absolute;
    height: 125px;
    right: 0;
    left: 0;
    top: -125px;
    padding-top: 12px;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.57);

    h4 {
      font-size: 22px;
    }
  }

  .section2-step {
    position: relative;
    display: block;
    margin-top: -345px;
    .common-card {
      margin-left: 0px;
    }
  }
}
</style>
